import axios from "axios";
import { getTokenFromCookies } from "@/utils/common";
import store from "@/store";
import router from "@/router";
import firebase from "firebase/compat";
import onLog = firebase.onLog;

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getTokenFromCookies();
  if (token) {
    config.headers["x-session-token"] = token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!getTokenFromCookies()) return;
    console.error("API Error:", error);
    if (
      error.response?.status === 401 &&
      !error.config?.url?.includes("/logout")
    ) {
      if (getTokenFromCookies()) await store.dispatch("auth/logout");
      router.push({ name: "Login" });
      return new Promise(() => {
        console.log("401: Неавторизованный пользователь");
      });
    }
    return Promise.reject(error);
  }
);

export default api;
